<template>
  <v-row align="center" class="flex-nowrap fill-height ticker" no-gutters style="position: relative;">
    <v-col :key="index" cols="auto" v-for="(stock, index) in stockData">
      <v-row class="flex-nowrap" no-gutters>
        <div class="text-uppercase font-weight-bold mr-2">{{ stock.ticker_symbol }}</div>
        <div class="font-weight-thin mr-1">{{ stock.shares_traded }}</div>
        <div class="font-weight-bold mr-2">{{ stock.price_traded }}</div>
        <div class="mx-3" style="position: relative;">
          <v-icon :color="stock.change_direction === 'pos' ? 'success' : 'error'"
                  style="position: absolute; left: -15px;"
          >{{ stock.change_direction === 'pos' ? 'mdi-menu-up' : 'mdi-menu-down' }}
          </v-icon>
        </div>
        <div class="font-weight-bold mr-2">{{ stock.change_amount }}</div>
        <div class="mr-2" v-if="index < stockData.length -1">|</div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "StocksTicker",
  props: {
    stockData: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.ticker {
  display: flex;
  position: absolute;
  left: 100%;
  /*overflow: hidden;*/
  animation-play-state: paused;
  animation: scroll 30s linear 1s infinite;
}

@keyframes scroll {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-280%);
  }
}
</style>